import { render, staticRenderFns } from "./AccountManagementLogin.vue?vue&type=template&id=23f3a855&scoped=true&"
import script from "./AccountManagementLogin.vue?vue&type=script&lang=js&"
export * from "./AccountManagementLogin.vue?vue&type=script&lang=js&"
import style0 from "./AccountManagementLogin.vue?vue&type=style&index=0&id=23f3a855&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3a855",
  null
  
)

export default component.exports